import { createStore } from "redux";
import { createEpicMiddleware, createStateStreamEnhancer } from "redux-most";
import rootReducer from "root/rootReducer";
import rootEpic from "root/rootEpic";
import { composeWithDevTools } from 'redux-devtools-extension';

const epicMiddleware = createEpicMiddleware(rootEpic);

const configureMiddleware = () => {
  const store = createStore(
    rootReducer,
    composeWithDevTools(createStateStreamEnhancer(epicMiddleware)),
  );

  if (module.hot) {
    module.hot.accept("root/rootReducer", () => {
      const rootReducer = require("root/rootReducer").default;
      store.replaceReducer(rootReducer);
    });

    module.hot.accept("root/rootEpic", () => {
      const rootEpic = require("root/rootEpic").default;
      epicMiddleware.replaceEpic(rootEpic);
    });
  }

  return store;
};

export default configureMiddleware;
